export default function stopPropagation(e:React.SyntheticEvent) {
    e.stopPropagation()
}
